import { render, staticRenderFns } from "./inactive-preview-form.component.vue?vue&type=template&id=2c6a0445&"
import script from "./inactive-preview-form.component.ts?vue&type=script&lang=ts&"
export * from "./inactive-preview-form.component.ts?vue&type=script&lang=ts&"
import style0 from "./inactive-preview-form.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports